export const PAGE_UPDATE = 'PAGE_UPDATE';
export const FETCH_TEETIMES = 'FETCH_TEETIMES';
export const TEETIMES_FETCHED = 'TEETIMES_FETCHED';
export const TEETIMES_FETCHING = 'TEETIMES_FETCHING';
export const CONTENT_LOADED = 'CONTENT_LOADED';
export const CREATE_RESERVATION = 'CREATE_RESERVATION';
export const CREATING_RESERVATION = 'CREATING_RESERVATION';
export const RESERVATION_PLACED = 'RESERVATION_PLACED';
export const RESERVATION_FAILED = 'RESERVATION_FAILED';
export const TEETIMES_RESPONSE = 'TEETIMES_RESPONSE';
export const CALANDER_UPDATE = 'CALANDER_UPDATE';
export const TIMERANGE_UPDATE = 'TIMERANGE_UPDATE';
export const PRICERANGE_UPDATE = 'PRICERANGE_UPDATE';
export const HOLECOUNT_UPDATE = 'HOLECOUNT_UPDATE';
export const GOLFCART_UPDATE = 'GOLFCART_UPDATE';
export const GOLFERCOUNT_UPDATE = 'GOLFERCOUNT_UPDATE';
export const TEETIME_SELECTED = 'TEETIME_SELECTED';
export const TEETIME_GOLFERCOUNT_SELECTED = 'TEETIME_GOLFERCOUNT_SELECTED';
export const CANCEL_SELECTED_TEETIME = 'CANCEL_SELECTED_TEETIME';
export const RESET_FILTERS = 'RESET_FILTERS';
export const TAKE_FILTER_SNAPSHOT = 'TAKE_FILTER_SNAPSHOT';
export const RELEASE_FILTER_SNAPSHOT = 'RELEASE_FILTER_SNAPSHOT';
export const CONTENT_UPDATED = 'CONTENT_UPDATED';
export const MOBILE_LOAD_MORE = 'MOBILE_LOAD_MORE';
export const DRAWER_OPENED = 'DRAWER_OPENED';
export const DRAWER_CLOSED = 'DRAWER_CLOSED';
export const SCROLL_TO_TOP = 'SCROLL_TO_TOP';
export const TEETIME_UNAVAILIBLE = 'TEETIME_UNAVAILIBLE';
export const UNSET_TEETIME_UNAVAILIBLE_ERROR = 'UNSET_TEETIME_UNAVAILIBLE_ERROR';
export const SHOW_GOLFER_MODAL = 'SHOW_GOLFER_MODAL';




// WEBPACK FOOTER //
// ./src/actions/index.js